import { FormSection } from '../ui/FormSection';

export interface EventLocationFieldsProps {
  locationName: string;
  onLocationNameChange: (value: string) => void;
  locationStreet: string;
  onLocationStreetChange: (value: string) => void;
  locationCity: string;
  onLocationCityChange: (value: string) => void;
  locationState: string;
  onLocationStateChange: (value: string) => void;
  locationZipCode: string;
  onLocationZipCodeChange: (value: string) => void;
  locationCountry: string;
  onLocationCountryChange: (value: string) => void;
  isSubmitting: boolean;
}

export const EventLocationFields = ({
  locationName,
  onLocationNameChange,
  locationStreet,
  onLocationStreetChange,
  locationCity,
  onLocationCityChange,
  locationState,
  onLocationStateChange,
  locationZipCode,
  onLocationZipCodeChange,
  locationCountry,
  onLocationCountryChange,
  isSubmitting,
}: EventLocationFieldsProps) => (
  <FormSection title="Event Location">
    <p className="text-sm text-gray-600">
      The event location defaults to the venue address but can be overridden if the event is at a
      different location.
    </p>

    {/* Location Name */}
    <div>
      <label htmlFor="locationName" className="block text-sm font-medium text-gray-700 mb-1">
        Location Name
      </label>
      <input
        id="locationName"
        type="text"
        value={locationName}
        onChange={(e) => onLocationNameChange(e.target.value)}
        disabled={isSubmitting}
        placeholder="e.g., Downtown Restaurant"
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
          isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
      />
    </div>

    {/* Street Address */}
    <div>
      <label htmlFor="locationStreet" className="block text-sm font-medium text-gray-700 mb-1">
        Street Address
      </label>
      <input
        id="locationStreet"
        type="text"
        value={locationStreet}
        onChange={(e) => onLocationStreetChange(e.target.value)}
        disabled={isSubmitting}
        placeholder="123 Main St"
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
          isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
      />
    </div>

    {/* City, State, Zip in a grid */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {/* City */}
      <div className="md:col-span-1">
        <label htmlFor="locationCity" className="block text-sm font-medium text-gray-700 mb-1">
          City
        </label>
        <input
          id="locationCity"
          type="text"
          value={locationCity}
          onChange={(e) => onLocationCityChange(e.target.value)}
          disabled={isSubmitting}
          placeholder="Napa"
          className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
            isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''
          }`}
        />
      </div>

      {/* State */}
      <div className="md:col-span-1">
        <label htmlFor="locationState" className="block text-sm font-medium text-gray-700 mb-1">
          State
        </label>
        <input
          id="locationState"
          type="text"
          value={locationState}
          onChange={(e) => onLocationStateChange(e.target.value)}
          disabled={isSubmitting}
          placeholder="CA"
          className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
            isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''
          }`}
        />
      </div>

      {/* Zip Code */}
      <div className="md:col-span-1">
        <label htmlFor="locationZipCode" className="block text-sm font-medium text-gray-700 mb-1">
          Zip Code
        </label>
        <input
          id="locationZipCode"
          type="text"
          value={locationZipCode}
          onChange={(e) => onLocationZipCodeChange(e.target.value)}
          disabled={isSubmitting}
          placeholder="94558"
          className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
            isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''
          }`}
        />
      </div>
    </div>

    {/* Country */}
    <div>
      <label htmlFor="locationCountry" className="block text-sm font-medium text-gray-700 mb-1">
        Country
      </label>
      <input
        id="locationCountry"
        type="text"
        value={locationCountry}
        onChange={(e) => onLocationCountryChange(e.target.value)}
        disabled={isSubmitting}
        placeholder="USA"
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
          isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
      />
    </div>
  </FormSection>
);
